<template lang="html">

  <section class="interface_labels">
    <div class="row">
      <div class="col-lg-12 grid-margin stretch-card">
        <div class="card">
          <div class="col-lg-12 card-body row">
            <div class="col-lg-12">
              <h4 class="card-title">Api Json Testing</h4>
            </div>
            <div class="col-lg-4">             
              <div class="col-lg-12 row">
                <b-pagination
                   align="fill"
                  limit="6"
                  v-model="currentPage"
                  :total-rows="totalRowsResult"
                  :per-page="perPage"
                  first-text="<<"
                  prev-text="<"
                  next-text=">"
                  last-text=">>"
                  ellipsisText="..."
                  aria-controls=""
                  class="col-lg-10"
                ></b-pagination>               
              </div>
            </div>
            <div class="col-lg-1">
                <b-form-select id="perPage-dd" v-model="perPage" class="col-lg-12">
                 <b-form-select-option value="5">5</b-form-select-option>
                  <b-form-select-option value="10">10</b-form-select-option>
                  <b-form-select-option value="20">20</b-form-select-option>
                  <b-form-select-option value="50">50</b-form-select-option>
                  <b-form-select-option value="100">100</b-form-select-option>
                </b-form-select>
            </div>
            <div class="col-lg-7">
              <input type="checkbox" v-model="onlyActive">&nbsp;Active only
              <span class="float-right">
                <b-button variant="primary mr-1" @click="refreshTable"><i class="mdi mdi-refresh"></i>Refresh Table</b-button>
                <b-button variant="primary mr-1" @click="runCompare(null)"><i class="mdi mdi-run"></i>Run Job Compare</b-button>
              </span>
            </div>
            <b-table ref="interface_api_json_tab"
              id="table" 
              striped 
              hover 
              responsive 
              :items="items" 
              :fields="fields"
              :per-page="perPage"
              :current-page="1"
              primary-key="id"
              no-local-sorting
              no-provider-paging
              sort-icon-left
            >
              <!-- A custom formatted column -->            
              <template  v-slot:cell(asIsDetail)="data" lang="html">
                <b-row>
                  <h4 class="panel-title" style="margin:auto;">
                    <a role="button" data-toggle="collapse" href="javascript:void(0);" @click="openModal(data.item.urlAsIs)" aria-expanded="true" aria-controls="collapseOne">
                      <i class="mdi mdi-open-in-new"></i>
                    </a>
                  </h4>
                </b-row>
              </template>
              <template  v-slot:cell(toBeDetail)="data" lang="html">
                <b-row>
                  <h4 class="panel-title" style="margin:auto;">
                    <a role="button" data-toggle="collapse" href="javascript:void(0);" @click="openModal(data.item.urlToBe)" aria-expanded="true" aria-controls="collapseOne">
                      <i class="mdi mdi-open-in-new"></i>
                    </a>
                  </h4>
                </b-row>
              </template>
              <template  v-slot:cell(diffDetail)="data" lang="html">
                <b-row>
                  <h4 class="panel-title" style="margin:auto;">
                    <a role="button" data-toggle="collapse" href="javascript:void(0);" @click="openModal(data.item.diff)" aria-expanded="true" aria-controls="collapseOne">
                      <i class="mdi mdi-open-in-new"></i>
                    </a>
                  </h4>
                </b-row>
              </template>
              <template v-slot:cell(activeButton)="data" lang="html">
                <b-row>
                 <h4 class="panel-title" style="margin:auto;">                 
                  <b-button v-if="!data.item.disableTest" class="col-lg-5 p-1 m-auto" size="sm" style="max-width: 2.875rem;" variant="primary" v-b-tooltip.hover title="Incluso nei test" @click="curItem=data.item; toggleElementStatus(data.item,true)">
                    <i class="mdi mdi-close-outline btn-outline-secondary" style="display: block;"></i>
                  </b-button>
                  <b-button v-else class="col-lg-5 p-1 m-auto" size="sm" style="max-width: 2.875rem;" variant="danger" v-b-tooltip.hover title="Escluso dai test" @click="curItem=data.item; toggleElementStatus(data.item,false)">
                    <i class="mdi mdi-check-outline btn-outline-success" style="display: block;"></i>
                  </b-button>
                  
                  <b-button variant="primary" class="col-lg-5 p-1 ml-1" size="sm" style="max-width: 2.875rem;" @click="runCompare(data.item.id)"><i class="mdi mdi-run" style="display: block;"></i></b-button>
                </h4>
                </b-row>
              </template>
            </b-table>
            
          </div>
        </div>
      </div>
    </div>
  </section>

</template>
<style>
  .table td, .table th {
    max-width: 25vw;
}

li.nav-item.active > a {
  color: #fff!important;
    text-shadow: 2px 2px 4px rgba(100,100,100,0.5);
}
</style>
<script lang="js">
import { mapState, mapActions, mapGetters } from "vuex";
 const FileDownload = require('js-file-download');
export default {
  name: 'interface_labels',
  methods: {
    deleteItem(item) {
      this.$bvModal.msgBoxConfirm('Vuoi veramente cancellare '+item.code+'?', {
        title: 'Elimina',
        //size: 'sm',
        //buttonSize: 'sm',
        //headerBgVariant: 'danger',
        okVariant: 'danger',
        okTitle: 'Elimina',
        cancelTitle: 'Annulla',
        //footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true
      })
        .then(value => {
            this.axios
            .delete('/ccb/auth/fe/interfaceLabel/' + item.id ,this.authHeader)
            .then(response => {
               this.$bvModal.msgBoxOk(response.data.message, {
                okVariant: 'success',
                hideHeaderClose: false,
                centered: true
              })
             this.$bvModal.hide('modal-edit')
             this.refreshTable()
              this.curItem=null
            }
            )           

        })
        .catch(err => {
          // An error occurred
        })
    },
    toggleElementStatus(item,visibilityValue) {
      var stato = (visibilityValue) ? 'disattivare' : 'attivare'
      this.$bvModal.msgBoxConfirm('Vuoi '+stato+' l\'esecuzione di questa riga nei test?', {
        title: 'Cambio Stato Disable test',
        okVariant: 'danger',
        okTitle: 'Procedi',
        cancelTitle: 'Annulla',
        hideHeaderClose: false,
        centered: true
      })
      .then(value => {
        if(value){
          item.disableTest=visibilityValue;
          this.saveCurItem(item, "toggle");         
        }
            

        })
        .catch(err => {
        })
    },
    saveCurItem(curItem) {
      window.curr = curItem
      
      this.axios
        .put('/ccb/auth/fe/apiJsonTesting/' + curItem.id, curItem ,this.authHeader)
        .then(response => {
          this.$bvModal.msgBoxOk(response.data.message, {
                okVariant: 'success',
                hideHeaderClose: false,
                centered: true
              })
          //this.refreshTable()
          this.$bvModal.hide('modal-edit')
        }
          
        )
     
    },
    search() {
      this.setLastSearch(this.search) 
      this.setSpinnerStatus(true);
      var params = {
           page: this.currentPage - 1, size: this.perPage, sortBy: this.sortBy, sortDesc: this.sortDesc
            }
      var url = '/ccb/auth/fe/apiJsonTesting/allPaged';
      if (this.onlyActive) url = '/ccb/auth/fe/apiJsonTesting/activePaged'
      this.axios
      .get(url ,  {
        params: params,
        ...this.authHeader}          
          )
          .then((response) => {
          this.setSpinnerStatus(false);
          this.setApiJsonTest(response.data.content)
          this.totalRowsResult=this.totalRowsResult=response.data.totalElements;           
          });
    },
    runCompare(id) {
      // this.setLastSearch(this.search) 
      this.setSpinnerStatus(true);
      var params = {}
      var url = '/ccb/auth/fe/apiJsonTesting/confrontoJson';
      if (id) url +=('/'+id);
      this.axios
      .get(url ,  {
        params: params,
        ...this.authHeader}          
          );
          // .then((response) => {
           this.setSpinnerStatus(false);
          // this.setApiJsonTest(response.data.content)
          // this.totalRowsResult=this.totalRowsResult=response.data.totalElements;           
          // })
      this.$bvModal.msgBoxOk("Compare in esecuzione", {
                okVariant: 'success',
                hideHeaderClose: false,
                centered: true
              })
    },    
    openModal(message) {
      this.$bvModal.msgBoxOk(this.htmlToVNode(message.replaceAll("\n","<br/>")), {
                okVariant: 'success',
                hideHeaderClose: false,
                centered: true
              })
    },
    htmlToVNode(html) {
      return [
        this.$createElement('div', { domProps: { innerHTML: html } })
      ]
    },
    refreshTable() {
      this.search();
    },
    ...mapActions([
      'setCurApp',
      'setSpinnerStatus',
      'setLastSearch',
      'setInterfaceLabels',
      'setCurLabelGroup',
      'setApiJsonTest'
      
    ])
  },
  data () {
    return {   
     totalRowsResult: 0,
      routerParams: null,
      currentPage:1,
      perPage:100,
      sortBy:'id',
      sortDesc: false,
      curItem: null,
      newItem : {id:null, language: null,  labelGroup: null, code : null ,label: null ,modelEnableRegexp: 'DEFAULT' , modelDisableRegexp: null},
      onlyActive: true,
      fields: [
        {
          key: 'id',
          label: 'ID',
          sortable: false
        },
        {
          key: 'urlAsIs',
          label: 'urlAsIs',
          sortable: false,
          tdClass: 'rtlTd'
        },
        {
          key: 'asIsDetail',
          label: '',
          sortable: false
        },
        {
          key: 'urlToBe',
          label: 'urlToBe',
          sortable: false,
          tdClass: 'rtlTd'
        },
        {
          key: 'toBeDetail',
          label: '',
          sortable: false
        },
        {
          key: 'diff',
          label: 'Diff ',
          sortable: false
        },
        {
          key: 'diffDetail',
          label: '',
          sortable: false
        },
        {
          key: 'activeButton',
          label: 'Disable test',
          sortable: false
        }
      ],
      labelFilter: '',
      codeFilter: ''
    }
  },
  computed: {
    items () {
      return (this.getApiJsonTest && this.getApiJsonTest.length) ? this.getApiJsonTest : [];
    },
    ...mapState([
      'curLanguage',
      'curModel',
      'languages',
      'models'
    ]),
    ...mapGetters([
      'getCurModel7DigitsCode',
      'getLanguageLabel',
      'authHeader',
      'uploadCsvJSON',
      'getInterfaceLabels',
      'getLabelGroupList',
      'getCurLabelGroup',
      'getCurLanguage',
      'getCurLanguageObj',
      'getCurModel',
      'getApiJsonTest'
    ])
  },
   watch: {
     $route (to,from){
       this.routerParams = to;
       if(to.query.activeGroup && to.query.activeGroup !=null){
          this.setCurLabelGroup(to.query.activeGroup);        
        }
       if(to.query.action && to.query.action === 'search'){
        this.search();        
       }
     },   
    items (oldValue, newValue) {
      //console.log(this.$refs)
      //this.$refs.interface_labels_tab.refresh();
    },
    currentPage(newValue,oldValue){
      this.refreshTable();
    },
    perPage(newValue,oldValue){
      this.refreshTable();
    },
    sortBy(newValue,oldValue){
      this.refreshTable();
    },
    sortDesc(newValue,oldValue){
      this.refreshTable();
    },
    onlyActive(newValue,oldValue){
      this.refreshTable();
    }
  },
  updated(){
  },
  mounted() { 
    window.scoper = this
         //alert('search')
        this.search();        
       
    this.setCurApp('ccadm');
  }
}
</script>

<style scoped lang="scss">
@import "../../assets/scss/_variables.scss";
.collapse {
  border: 1px solid $gray-lightest;
  border-radius: 0.25rem;
}
</style>
